(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-ladder"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__giftLadderReady) return;
    window.__giftLadderReady = true;

    var CART_CALL = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
    var announce = function () {
      document.dispatchEvent(new CustomEvent('giftladder:cartchange'));
    };

    /* fetch hook */
    var nativeFetch = window.fetch;
    if (nativeFetch) {
      window.fetch = function () {
        var req = arguments[0];
        var url = typeof req === 'string' ? req : (req && req.url) || '';
        var p = nativeFetch.apply(this, arguments);
        if (CART_CALL.test(url)) p.then(announce).catch(function () {});
        return p;
      };
    }

    /* XHR hook */
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === 'string' && CART_CALL.test(url)) {
        this.addEventListener('loadend', announce);
      }
      return nativeOpen.apply(this, arguments);
    };

    class GiftLadder extends HTMLElement {
      connectedCallback() {
        this.steps = Array.prototype.map.call(
          this.querySelectorAll('[data-glad-step]'),
          function (el) {
            return {
              el: el,
              limit: Number(el.dataset.threshold) || 0,
              gift: el.dataset.giftMsg || el.dataset.gift || ''
            };
          }
        );
        this.msgEl = this.querySelector('.glad__msg');
        this.tplMsg = this.dataset.msg || '';
        this.tplDone = this.dataset.msgDone || '';
        this.firstPaint = true;
        this.money = this.makeMoney(this.dataset.currency);

        this.onCartChange = this.pullCart.bind(this);
        this.onPageShow = function (e) { if (e.persisted) this.pullCart(); }.bind(this);
        document.addEventListener('giftladder:cartchange', this.onCartChange);
        window.addEventListener('pageshow', this.onPageShow);

        this.paint(Number(this.dataset.total) || 0);
        this.pullCart();
      }

      disconnectedCallback() {
        document.removeEventListener('giftladder:cartchange', this.onCartChange);
        window.removeEventListener('pageshow', this.onPageShow);
      }

      makeMoney(currency) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
            style: 'currency',
            currency: currency || 'INR',
            maximumFractionDigits: 0
          });
        } catch (e) {
          return { format: function (n) { return String(Math.round(n)); } };
        }
      }

      pullCart() {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var self = this;
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { self.paint(cart.total_price); })
          .catch(function () {});
      }

      paint(total) {
        var steps = this.steps;
        if (!steps.length) return;

        var reached = 0;
        steps.forEach(function (s) { if (total >= s.limit) reached++; });

        var progress = 0;
        var count = steps.length;
        if (count === 1) {
          progress = reached ? 1 : 0;
        } else if (reached >= count) {
          progress = 1;
        } else if (reached > 0) {
          var lo = steps[reached - 1].limit;
          var hi = steps[reached].limit;
          var part = hi > lo ? (total - lo) / (hi - lo) : 0;
          progress = (reached - 1 + part) / (count - 1);
        }
        this.style.setProperty('--glad-p', Math.max(0, Math.min(1, progress)).toFixed(4));

        var animate = !this.firstPaint;
        steps.forEach(function (s, i) {
          var unlocked = i < reached;
          var was = s.el.classList.contains('is-unlocked');
          s.el.classList.toggle('is-unlocked', unlocked);
          if (unlocked && !was && animate) {
            s.el.classList.remove('is-popping');
            void s.el.offsetWidth;
            s.el.classList.add('is-popping');
          }
        });
        this.firstPaint = false;

        var next = steps[reached];
        var text = next
          ? this.tplMsg
              .replace('{amount}', this.money.format((next.limit - total) / 100))
              .replace('{gift}', next.gift)
          : this.tplDone;
        this.setMessage(text);
      }

      setMessage(text) {
        var el = this.msgEl;
        if (!el || el.textContent.trim() === text) return;
        el.classList.add('is-swapping');
        setTimeout(function () {
          el.textContent = text;
          el.classList.remove('is-swapping');
        }, 220);
      }
    }

    if (!customElements.get('gift-ladder')) {
      customElements.define('gift-ladder', GiftLadder);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
